<script setup lang="ts">
import { useSearch } from '@base/composables/search'
import { ut_getText } from '@base/utils/utils'

const cp = useSearch()
</script>

<template>
  <UContainer>
    <h1 class="mb-4" v-html="ut_getText('def_search-result_txt_page')" />
    <div v-if="cp.searchData.value">
      <div class="mb-6" v-html="ut_getText('def_search_txt_results', [cp.totalCount.value.toString(), cp.indexStore.state.paramData.queryUrlServer.term || ''])" />

      <div v-if="cp.totalCount.value > 0" class="overflow-auto">
        <table>
          <thead>
            <tr>
              <th class="text-left hyphens-auto p-4" v-html="ut_getText('def_search_label_catdesc') + ' / ' + ut_getText('def_search_label_piddesc')" />
              <th class="text-left hyphens-auto p-4" v-html="ut_getText('def_search_label_foundvalue')" />
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in cp.searchData.value.found" :key="index" class="odd:bg-gunmetal-5 even:bg-gunmetal-4">
              <td class="text-left hyphens-auto p-4 text-primary underline font-bold">
                <NuxtLink :to="cp.linkPath(item.slugPaths[0] || '')">
                  <span v-html="item.nodeDesc" />
                </NuxtLink>
              </td>
              <td class="text-left hyphens-auto p-4" v-html="item.valueText ? item.propDesc + ': ' + item.valueText : item.nodeDesc" />
            </tr>
          </tbody>
        </table>
      </div>

      <ClientOnly>
        <!-- Load more -->
        <LazyObserver v-if="cp.useLoadMore.value" @update:intersect="cp.loadMore()" />
      </ClientOnly>
    </div>
  </UContainer>
</template>
